import { NAV_MENU_TYPE } from '../types';

export const HISTORY_KEY = 'history';

export const NAV_LIST_CLASS = '.patsnap-biz-ai-history-nav-list';

export const LIGHT_ACTIVE_CLASS = 'bg-gray-hover tippy-content-active';

export const BORDER_ACTIVE_CLASS = 'active-menu-item';

export const MENU_LIST_CONFIG = [
    {
        type: NAV_MENU_TYPE.HOME,
        icon: 'SolidHome',
        link: '/home',
        router: '/home',
        module: NAV_MENU_TYPE.HOME,
    },
    {
        type: NAV_MENU_TYPE.CUSTOM_AGENT,
        icon: 'SolidInsightsTechnology',
        link: '/explore',
        router: '/explore',
        module: NAV_MENU_TYPE.CUSTOM_AGENT,
        authKey: 'custom_table_permission',
    },
    {
        type: NAV_MENU_TYPE.AI_STUDIO,
        icon: 'SolidChartTopipc',
        link: '/ai-studio',
        router: '/agents',
        module: NAV_MENU_TYPE.AI_STUDIO,
        authKey: 'ai_agent_studio',
    },
    {
        type: NAV_MENU_TYPE.MONITOR,
        icon: 'SolidAim',
        link: '/monitor/#/my?from=invite-monitor-nav',
        router: '/my',
        module: NAV_MENU_TYPE.MONITOR,
    },
    {
        type: NAV_MENU_TYPE.WORK_PROJECT,
        icon: 'SolidFolderMany',
        link: '/rd/#/graph',
        router: '/graph',
        module: NAV_MENU_TYPE.WORK_PROJECT,
        authKey: 'work_project',
    }
];

export const INCOGNITO_MENU_ITEM = {
    type: NAV_MENU_TYPE.INCOGNITO,
    icon: 'SolidSecutiry',
}

export const EVENTS_CONFIG = {
    [NAV_MENU_TYPE.HOME]: 'SS Seek Search',
    [NAV_MENU_TYPE.AI_STUDIO]: 'SS AI Studio',
    [NAV_MENU_TYPE.AI_GENERATE]: 'SS AI Agent',
    [NAV_MENU_TYPE.MONITOR_TOPIC]: 'SS News Letter',
    [NAV_MENU_TYPE.MONITOR_SUBSCRIPTION]: 'SS News Letter',
    [NAV_MENU_TYPE.INCOGNITO]: 'SS Seek Search',
    [NAV_MENU_TYPE.WORK_PROJECT]: 'SS Work Project',
    [NAV_MENU_TYPE.SEEK_SEARCH]: 'SS Seek Search',
    [NAV_MENU_TYPE.TECH_MIND]: 'SS Idea AI',
    [NAV_MENU_TYPE.TECH_FMEA]: 'SS Tech FMEA',
    [NAV_MENU_TYPE.TECH_RESEARCH]: 'SS Project',
    [NAV_MENU_TYPE.IDEA_EXPLORATION]: 'SS Idea AI',
    [NAV_MENU_TYPE.TRIZ_MIND]: 'SS TRIZ',
    [NAV_MENU_TYPE.RD_TECH_MIND]: 'SS RD Tech Mind',
};

export const SAVED_OPENED_KEY = 'COMMON_NAV_COLLAPSE';

export const ROUTE_NAME_WHITELIST = ['chatDetail'];
